<app-page-content [showProgress]="progress">
  <span pagetitle>Tildel turer til bruker</span>

  <div pagecontent style="margin-bottom: 4em">
    <mat-form-field style="width: 100%; margin-top: 0.5em" floatLabel="always">
      <mat-label>Bruker</mat-label>
      <mat-select [(value)]="user" [disabled]="users.length == 0" required>
        <mat-option *ngFor="let user of users" [value]="user.Id">{{ user.Name }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <app-button-box pagefooter>
    <button mat-raised-button color="warn" (click)="cancel()">AVBRYT</button>
    <button style="margin-right: 0.5em" mat-raised-button color="primary" (click)="assign()" [disabled]="user == null || user == ''">TILDEL</button>
  </app-button-box>
</app-page-content>
